import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Section = styled.section`
  padding: 80px 0;
  background-color: #f8fafc;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled(motion.h2)`
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 3rem;
  color: #1f2937;

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const ContactContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;
`;

const ContactCard = styled(motion.div)`
  background: white;
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e5e7eb;
  text-align: center;
  max-width: 600px;
  width: 100%;
`;

const ContactTitle = styled.h3`
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1f2937;
`;

const ContactDescription = styled.p`
  color: #6b7280;
  margin-bottom: 2rem;
  line-height: 1.6;
  font-size: 1.125rem;
`;

const EmailLink = styled(motion.a)`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  background: linear-gradient(135deg, #1e40af, #3b82f6);
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.25rem;
  font-weight: 600;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
  }

  i {
    font-size: 1.5rem;
  }
`;

const ContactInfo = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
`;

const InfoText = styled.p`
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
`;

const Contact = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <Section id="contact">
      <Container>
        <SectionTitle
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          Get Involved
        </SectionTitle>
        
        <ContactContent>
          <ContactCard
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <ContactTitle>Engagement Committee</ContactTitle>
            <ContactDescription>
              Join us in making Tech Week 2026 even more impactful for our community. 
              Reach out to learn more about getting involved or to share your ideas.
            </ContactDescription>
            
            <EmailLink
              href="mailto:chip@LaFleur.Marketing"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <i className="fas fa-envelope"></i>
              chip@LaFleur.Marketing
            </EmailLink>
            
            <ContactInfo>
              <InfoText>
                Contact Chip LaFleur for committee information, partnership opportunities, 
                or to discuss how you can contribute to Tech Week 2026.
              </InfoText>
            </ContactInfo>
          </ContactCard>
        </ContactContent>
      </Container>
    </Section>
  );
};

export default Contact;
